@if (value !== null && value !== undefined) {
  {{ value | number: '1.' + decimals + '-' + decimals : 'da' }}
} @else {
  <span class="text-slate-300">-</span>
}
